<app-main-navigation></app-main-navigation>
<app-price-robot-submenu></app-price-robot-submenu>
<app-message-view></app-message-view>

<div class="container-fluid pb-1" [ngClass]="{faded:loading}" *ngIf="product; else spinner">
    <div class="card mt-4">
        <div class="card-header d-flex">
            <div class="pe-3">
                <ng-container
                    *ngIf="favorite; else notFavorite">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill=orange
                         class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path
                            d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                </ng-container>
                <ng-template #notFavorite>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-star mb-1" viewBox="0 0 16 16">
                        <path
                            d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/>
                    </svg>
                </ng-template>
            </div>
            <span>
                {{product.name}}
            </span>
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col-6">

                    <dl>

                        <dt>Producent</dt>
                        <dd>
                            <ng-container *ngIf="product.variants && product.variants.length > 0 && product.variants[0] !== null; else none">
                                <p>
                                    {{product.variants[0].name}}
                                </p>
                            </ng-container>
                        </dd>

                        <dt>
                            EAN
                        </dt>
                        <dd>
                            <ng-container *ngIf="product.getCustomFieldValue('ean')">
                                {{product.getCustomFieldValue('ean')}}
                            </ng-container>
                        </dd>

                        <dt>
                            DB
                        </dt>
                        <dd>
                                {{product?.external_reference}}
                        </dd>
                        <dt>Ansvarlig bruger</dt>
                        <ng-container *ngIf="product.users.length > 0; else none">
                            <ng-container *ngFor="let user of product.users" class="badge rounded-pill bg-secondary me-1">
                                <dd>{{user.name}}</dd>
                            </ng-container>
                        </ng-container>

                    </dl>
                </div>

                <div class="col-6">

                    <dl>
                        <dt>
                            10-4 link:
                        </dt>
                        <dd>
                            <ng-container *ngIf="product.getCustomFieldValue('original_url'); else none">
                                <a [href]="product.getCustomFieldValue('original_url')">
                                    {{product.getCustomFieldValue('original_url')}}
                                </a>
                            </ng-container>
                        </dd>

                        <dt>
                            Pris
                        </dt>
                        <dd>
                            <ng-container *ngIf="product.prices.length > 0; else none">
                                {{product.prices[0].price | number:'1.2-2':'da'}}
                            </ng-container>
                        </dd>
                    </dl>
                    <button class="btn btn-outline-primary mt-2" (click)="openModal(content)">
                        Edit product
                    </button>
                    <ng-template #content let-modal>
                        <div class="modal-header" [ngClass]="{faded:loading}">
                            <h4 class="modal-title">Ret produkt</h4>
                            <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" [ngClass]="{faded:loading}">
                            <div class="mt-4">
                                <div class="form-group">
                                    <label for="name">Navn</label>
                                    <input type="text" class="form-control" id="name" [(ngModel)]="product.name"
                                           name="name">
                                </div>
                                <div class="form-group">
                                    <label for="name">Noter</label>
                                    <textarea class="form-control" id="description" [(ngModel)]="product.description"
                                              name="description"></textarea>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="favorite"
                                           [(ngModel)]="favorite"
                                           name="favorite">
                                    <label class="form-check-label" for="favorite">
                                        Favorit
                                    </label>
                                </div>
                                  <div class="form-check">
                                    <input class="form-check-input" type="checkbox"  id="active"
                                           [(ngModel)]="product.price_adjustment.active"
                                           name="active">
                                    <label class="form-check-label" for="active">
                                        Aktiv prisrobot
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="is_paused"
                                           [(ngModel)]="product.price_adjustment.is_paused"
                                           name="is_paused">
                                    <label class="form-check-label" for="is_paused">
                                        Pause </label>
                                </div>

                                <div class="form-group mt-3">
                                    <label>Bruger</label><br>
                                    <ss-multiselect-dropdown name="foo" [options]="users"
                                                             [(ngModel)]="product.user_ids"></ss-multiselect-dropdown>
                                </div>
                                <input type="button" value="Gem produkt" (click)="saveProduct()" class="btn btn-primary"
                                       id="edit">
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div class="col-12">
                    <table class="table table-striped align-middle mt-4 table-sm" *ngIf="product">
                        <tr app-price-robot-product-header [filter]="{}"></tr>
                        <tbody>
                            <tr app-price-robot-product-row [product]="product"></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <ng-template #none>
            <p style="color: grey;">
                Ingen
            </p>
        </ng-template>


    </div>


    <div class="card mt-4 ">
        <div class="card-header d-flex">
        Actions:
        </div>
        <div class="card-body d-flex gap-2">
            <button (click)="rescan(false)" class="btn btn-primary">Rescan</button>
            <button (click)="rescan(true)" class="btn btn-secondary ">Rescan (force)</button>
        </div>
    </div>


    <app-price-robot-rules-list [rules]="rules" *ngIf="rules" [embedded]="true"></app-price-robot-rules-list>


    <button class="btn btn-outline-primary mt-2" (click)="startAddUrl(urlContent)">
       Add url
    </button>
    <ng-template #urlContent let-modal>
        <div class="modal-header" [ngClass]="{faded:loading}">
            <h4 class="modal-title">Url</h4>
            <button type="button" class="close" aria-label="Close"
                    (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" [ngClass]="{faded:loading}">
            <div class="mt-4">
                <div class="form-group">
                    <label for="users" class="">Competitor</label>
                    <select id="users" class="form-control custom-select " [(ngModel)]="priceRobotUrl.crawler_website_id"
                            name="users">
                        <option value="0" selected>Vælg</option>
                        <option *ngFor="let competitor of this.competitors | sortBy:'asc':'name'" value="{{competitor.id}}">{{competitor.name}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="name">URL</label>
                    <input class="form-control"  [(ngModel)]="priceRobotUrl.url"
                              name="url" />
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" [(ngModel)]="priceRobotUrl.apply_conversion">
                    <label class="form-check-label" for="defaultCheck1">
                       Brug omregning
                    </label>
                </div>


                <input type="button" value="Gem url" (click)="saveUrl()" class="btn btn-primary"
                >
            </div>
        </div>
    </ng-template>





    <div class="form-check ">
        <input type="checkbox" (change)="changeSorting()" [(ngModel)]="includeShipping" [value]="true"
               id="includeShipping"
               class="form-check-input">
        <label class="form-check-label" for="includeShipping"
        >Brug fragt i beregninger</label>
    </div>

    <ng-container *ngIf="product.crawler_urls.length !== 0; else noUrls">

        <table class="table table-striped align-middle mt-4 table-sm">
            <tr>
                <th class="align-top">Konkurrent</th>
                <th class="align-top">ID</th>
                <th class="align-top">URL</th>
                <th class="align-top">Logs</th>
                <th class="align-top">Sidste crawldato</th>
                <th class="align-top">Sidste crawler pris</th>
                <th class="align-top">Sidste crawler fragt</th>

                <th class="align-top">Afvigelse kr.<br><ng-container *ngIf="includeShipping">inkl. fragt</ng-container>&nbsp;</th>
                <th class="align-top">Afvigelse %<br><ng-container *ngIf="includeShipping">inkl. fragt</ng-container>&nbsp;</th>
                <th class="align-top">Screenshot</th>
                <th class="align-top"></th>
            </tr>
            <tbody>
            <tr *ngFor="let url of product.crawler_urls">
                <td>
                    <i *ngIf="!url.is_approved" class="me-1 text-danger fa fa-exclamation" ngbTooltip="Afventer godkendelse"></i>
                    <a [routerLink]="'/price-robot/competitor/' + url.crawler_website.id"
                    [queryParams]="{
                    urlId: url.id,
                    mode: url.is_approved ? 'approved' :'pending'} "
                    >{{url.crawler_website.name}}</a>
                </td>
                <td>
                    {{url.id}}
                </td>
                <td>
                    <a href="{{url.url}}" target="_blank">Eksternt link</a>
                </td>
                <td>
                    <a href="javascript:" (click)="openLargeModal(crawlerLogsContent)">logs</a>
                </td>
                <td class="text-nowrap">
                    <ng-container *ngIf="url.crawler_logs && url.crawler_logs.length > 0">
                        {{ url.crawler_logs[0] && url.crawler_logs[0].created.isValid() ? url.crawler_logs[0].created.format('DD.MM.YYYY HH:mm') : '-' }}
                        <span class="badge text-bg-primary rounded-pill" *ngIf="url.crawler_disabled">Pricerunner</span>
                        <span class="badge text-bg-warning rounded-pill" *ngIf="!url.crawler_disabled">Crawler</span>

                    </ng-container>
                </td>
                <td>
                    <ng-container *ngIf="url.crawler_logs && url.crawler_logs.length > 0">
                        <app-price-robot-error-display [process_result]="url.crawler_logs[0].process_result[0]"></app-price-robot-error-display>
                        {{url.crawler_logs[0].process_result[0].price  | number:'1.2-2':'da'}}
                    </ng-container>

                    <span class="badge text-bg-primary rounded-pill" *ngIf="url.apply_conversion">Bruger omregning: {{product.getCustomFieldValue('webprisfaktor')}}</span>

                </td>
                <td>
                    <ng-container *ngIf="url.crawler_logs && url.crawler_logs.length > 0">
                        {{url.crawler_logs[0].process_result[0].delivery  | number:'1.2-2':'da'}}
                    </ng-container>
                </td>

                <td>
                    {{url.diff | number:'1.2-2':'da'}}
                </td>
                <td>
                    <span *ngIf="url.pct_div else none" [ngClass]="{'text-success': url.pct_div > 0, 'text-danger': url.pct_div < 0}">
                        {{url.pct_div | number:'1.2-2':'da'}} %
                    </span>
                </td>

                <td>
                    <img *ngIf="url.screenshot_url && url.screenshot_url !== null" alt="screenshot" width="150" height="150"
                         src="{{url.screenshot_url}}" (click)="openLargeModal(imageContent)">
                </td>
                <td class="">
                    <div class="d-flex justify-content-between">

                    <button class="btn btn-link mx-2" (click)="crawl(url)">Crawl</button>
                    <button class="btn btn-link mx-2" (click)="rescan(true, url.crawler_website_id)">Rescan</button>
                    <button class="btn btn-outline-success mx-2" (click)="startEditUrl( urlContent, url)">Edit</button>
                    <button class="btn btn-outline-danger mx-2" (click)="deleteUrl(url)">Delete</button>
                    </div>
                </td>
                <ng-template #crawlerLogsContent>
                    <table class="table table-striped align-middle mt-4 table-sm">
                        <tr>
                            <th>date</th>
                            <th>price</th>
                            <th>delivery</th>
                            <th>screenshot</th>
                            <th>warning</th>
                            <th></th>
                        </tr>
                        <tr *ngFor="let crawler_log of url.crawler_logs | sortBy:'desc':'created'">
                            <td class="text-nowrap">
                                <ng-container *ngIf="crawler_log.created && crawler_log.created.isValid()">
                                    {{crawler_log.created.format('DD.MM.YYYY HH:mm')}}
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="crawler_log.process_result[0]">
                                    {{crawler_log.process_result[0].price}}
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="crawler_log.process_result[0]">
                                    {{  crawler_log.process_result[0].delivery}}
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="crawler_log.process_result[0]">
                                    <a [href]="crawler_log.process_result[0].screenshotUrl" target="_blank"
                                       *ngIf="crawler_log.process_result[0].screenshotUrl">
                                        <img alt="screenshot" width="150" height="150"
                                             [src]=" crawler_log.process_result[0].screenshotUrl">
                                    </a>
                                </ng-container>
                            </td>
                            <td>
                                <app-price-robot-error-display [process_result]="crawler_log.process_result[0]"></app-price-robot-error-display>
                            </td>
                        </tr>
                    </table>
                </ng-template>
                <ng-template #imageContent let-modal>
                    <div class="modal-header" [ngClass]="{faded:loading}">
                        <button type="button" class="close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" [ngClass]="{faded:loading}">
                        <img *ngIf="url.screenshot_url !== null" alt="screenshot" class="img-fluid"
                             src="{{url.screenshot_url}}">
                    </div>
                </ng-template>
            </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-center">
            <button class="btn-sm btn-primary mt-5 me-4" (click)="hideAll()">Skjul alle</button>
            <button class="btn-sm btn-primary mt-5" (click)="configureData(30)">Vis alle</button>
        </div>

        <canvas baseChart
                [data]="lineChartData"
                [type]="'line'">
        </canvas>

    </ng-container>
    <ng-template #noUrls>
        <h2 class="mt-5 d-flex justify-content-center">
            Produktet er ikke tilknyttet nogle url'er
        </h2>
    </ng-template>

</div>
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
